import moment from "moment";
import getUnidade from "@/utils/getUnidade";
import { CardAtendente } from "./CardAtendente";


export function Agentes({ data = [] , unidadeId}) {
  return (
    <div className="grid grid-cols-4 gap-4">
      {data.map((item) => (
        <CardAtendente
          key={item._id}
          atendente={item.atendente_info?.nome ?? "Sem Atendente"}
          total_finalizados={item.total_finalizados}
          total_andamento={item.solicitacoes.length}
          ultimo_registro={item.ultimo_registro ? moment(item.ultimo_registro).format('DD/MM/YY HH:mm') : null}
          ultimo_registro_toISOString={item.ultimo_registro}
          solicitacoes={item.solicitacoes}
          unidade={getUnidade(item.atendente_info?.empresa)}
          unidadeId={unidadeId}
        />
      ))}
    </div>
  )
}